import { gql } from '@apollo/client/core'
import Mail, { MailsByDomiciliations, Pagination, UserMailToForwardType } from 'globals/models/Mail'
import { PAGINATION_FRAGMENT, USER_MAIL_FRAGMENT } from './fragments'
import { Moment } from 'moment'

export const USER_MAILS = gql`
  query userMails(
    $search: String,
    $mailTypeCategory: UserMailTypeCategories!,
    $domiciliationId: ID!,
    $page: Int!,
    $pageLength: Int) {
    userMails(
      search: $search,
      domiciliationId: $domiciliationId,
      page: $page,
      pageLength: $pageLength,
      mailTypeCategory: $mailTypeCategory
    ) {
      mails {
        ...UserMailFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export interface UserMailsVariables {
  search: string,
  domiciliationId: number,
  page: number,
  pageLength: number
  mailTypeCategory: UserMailTypeCategory,
}

export enum UserMailTypeCategory {
  Courrier = 'Courrier',
  Colis = 'Colis',
  All = 'All'
}

export interface UserMailsResult {
  userMails: {
    mails: Mail[],
    pagination: Pagination
  }
}

export const USER_MAILS_HISTORY = gql`
  query userMailsHistory($search: String, $domiciliationId: ID!, $page: Int!, $pageLength: Int) {
    userMailsHistory(
      search: $search,
      domiciliationId: $domiciliationId,
      page: $page,
      pageLength: $pageLength
    ) {
      pagination {
        ...PaginationFragment
      }
      userMailsHistory {
        ...UserMailFragment
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export interface UserMailsHistoryVariables {
  search: string,
  domiciliationId: number,
  page: number,
  pageLength: number
}

export interface UserMailsHistoryResult {
  userMailsHistory: {
    pagination: Pagination,
    userMailsHistory: Mail[]
  }
}

export const MAILS_TO_FORWARD = gql`
  query userMailsToForward($search: String, $mailType: UserMailToForwardTypes, $page: Int!, $pageLength: Int!) {
    userMailsToForward(search: $search, mailType: $mailType, page: $page, pageLength: $pageLength) {
      pagination {
        ...PaginationFragment
      }
      userMailsToForwardByDomiciliation {
        domiciliation {
          id
          firstname
          lastname
          society {
            id
            name
          }
        }
        forwardingAddress {
          id
          name
          streetAddress
          postalCode
          city
          country
        }
        userMailsCount
        userMails {
          ...UserMailFragment
        }
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export interface MailsToForwardVariables {
  search?: string,
  mailType?: UserMailToForwardType,
  page: number,
  pageLength: number
}

export interface MailsToForwardResult {
  userMailsToForward: {
    pagination: Pagination,
    userMailsToForwardByDomiciliation: MailsByDomiciliations[]
  }
}

export const MAILS_TO_FORWARD_MINI = gql`
  query userMailsToForward($search: String, $mailType: UserMailToForwardTypes, $page: Int!, $pageLength: Int!) {
    userMailsToForward(search: $search, mailType: $mailType, page: $page, pageLength: $pageLength) {
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${PAGINATION_FRAGMENT}
`

export const MAILS_TO_PROVISIONED = gql`
  query userMailsToProvision($date: ISO8601DateTime!) {
    userMailsToProvision(date: $date) {
      totalCount
      userMailsByDomiciliation {
        domiciliation {
          id
          firstname
          lastname
          society {
            id
            name
          }
        }
        forwardingAddress {
          id
          name
          streetAddress
          postalCode
          city
          country
        }
        userMailsCount
        userMails {
          ...UserMailFragment
        }
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
`

export interface MailsToProvisionedVariables {
  date: Moment,
  page: number,
  pageLength: number
}

export interface MailsToProvisionedResult {
  userMailsToProvisioned: {
    totalCount: number,
    userMails: MailsByDomiciliations[]
  }
}

export const MAILS_TO_DESTROY = gql`
  query userMailsToDestroy($search: String, $page: Int!, $pageLength: Int!) {
    userMailsToDestroy(search: $search, page: $page, pageLength: $pageLength) {
      pagination {
        ...PaginationFragment
      }
      userMailsToDestroyByDomiciliation {
        domiciliation {
          id
          firstname
          lastname
          society {
            id
            name
          }
        }
        forwardingAddress {
          id
          name
          streetAddress
          postalCode
          city
          country
        }
        userMailsCount
        userMails {
          ...UserMailFragment
        }
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export interface MailsToDestroyVariables {
  search: string,
  page: number,
  pageLength: number
}

export interface MailsToDestroyResult {
  userMailsToDestroy: {
    pagination: Pagination,
    userMailsToDestroyByDomiciliation: MailsByDomiciliations[]
  }
}

export const VALIDATE_USER_MAIL_PROVISIONING_BATCHS = gql`
  mutation validateUserMailsProvisioningBatches(
    $receivedUserMailIds: [ID]!
    $notReceivedUserMailIds: [ID]!
    ) {
      validateUserMailsProvisioningBatches(
        receivedUserMailIds: $receivedUserMailIds
        notReceivedUserMailIds: $notReceivedUserMailIds
      ) {
        success
      }
    }
`

export const USER_MAIL_ROLLBACK_ACTION = gql`
  mutation userMailRollbackAction(
    $userMailId: ID!
    ) {
      userMailRollbackAction(
        userMailId: $userMailId
      ) {
        userMail {
          ...UserMailFragment
        }
      }
    }
  ${USER_MAIL_FRAGMENT}
`
